var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChangeAddress',_vm._b({},'ChangeAddress',_vm.componentData,false))
}
var staticRenderFns = []

export { render, staticRenderFns }